import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SITE } from "../i18n/translations";
import { useBooking } from "../context/BookingContext";
import TranslateButton from "./TranslateButton";

export default function FloatingWhatsApp() {
  const { t } = useLang();
  const { openBooking } = useBooking();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-[90] flex flex-col items-end gap-3" data-testid="floating-connect">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.9 }}
            className="glass-strong rounded-2xl p-4 w-64 space-y-2"
            data-testid="floating-menu"
          >
            <button
              onClick={() => { setOpen(false); openBooking(); }}
              className="w-full text-left rounded-xl px-4 py-3 text-sm text-tara-ink bg-white/70 hover:bg-white transition flex items-center gap-2"
              data-testid="floating-request-guidance"
            >
              <MessageCircle className="h-4 w-4 text-tara-gold" /> {t("cta_request")}
            </button>
            <a
              href={`https://wa.me/${SITE.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full rounded-xl px-4 py-3 text-sm text-tara-ink bg-green-600/20 hover:bg-green-600/30 transition flex items-center gap-2"
              data-testid="floating-whatsapp-direct"
            >
              <MessageCircle className="h-4 w-4 text-green-600" /> {t("cta_whatsapp")}
            </a>
            <a
              href={`tel:+${SITE.whatsapp}`}
              className="w-full rounded-xl px-4 py-3 text-sm text-tara-ink bg-white/70 hover:bg-white transition flex items-center gap-2"
              data-testid="floating-call"
            >
              <Phone className="h-4 w-4 text-tara-gold" /> {SITE.phoneDisplay}
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <TranslateButton variant="floating" />

      <button
        onClick={() => setOpen((o) => !o)}
        className="aura-pulse flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-green-500 to-green-600 text-white shadow-2xl hover:scale-105 transition"
        data-testid="floating-connect-btn"
        aria-label="Connect on WhatsApp"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-7 w-7" />}
      </button>
    </div>
  );
}
